import { merge, createMetadataProvider, createChatProvider, createEmbedProvider, createModelProvider, createSpeechProvider, createTranscriptionProvider } from '@xsai-ext/shared-providers';

const createLiteLLM = (apiKey, baseURL = "http://localhost:4000/v1/") => merge(
  createMetadataProvider("litellm"),
  createChatProvider({ apiKey, baseURL }),
  createEmbedProvider({ apiKey, baseURL }),
  createModelProvider({ apiKey, baseURL }),
  createSpeechProvider({ apiKey, baseURL }),
  createTranscriptionProvider({ apiKey, baseURL })
);

const createLMStudio = (baseURL = "http://localhost:1234/v1/") => merge(
  createMetadataProvider("lmstudio"),
  /** @see {@link https://lmstudio.ai/models} */
  createChatProvider({ baseURL }),
  createEmbedProvider({ baseURL }),
  createModelProvider({ baseURL })
);

const createOllama = (baseURL = "http://localhost:11434/v1/") => merge(
  createMetadataProvider("ollama"),
  /** @see {@link https://ollama.com/models} */
  createChatProvider({ baseURL }),
  createEmbedProvider({ baseURL }),
  createModelProvider({ baseURL })
);

const decodeBase64 = (b64) => {
  const binString = atob(b64);
  const size = binString.length;
  const bytes = new Uint8Array(size);
  for (let i = 0; i < size; i++) {
    bytes[i] = binString.charCodeAt(i);
  }
  return bytes;
};

const createPlayer2 = (baseURL = "http://localhost:4315/v1/", gameKey = "xsai") => merge(createMetadataProvider("player2"), createChatProvider({ baseURL, headers: { "player2-game-key": gameKey } }), createSpeechProvider({
  baseURL,
  fetch: async (input, reqInit) => {
    const newUrl = `${input.toString().slice(0, -"audio/speech".length)}tts/speak`;
    try {
      const { input: input2, response_format, speed, voice, ...rest } = JSON.parse(reqInit?.body);
      const modified = {
        audio_format: response_format,
        play_in_app: false,
        speed: speed ?? 1,
        text: input2,
        voice_ids: voice != null ? [voice] : [],
        ...rest
      };
      if (reqInit) {
        reqInit.body = JSON.stringify(modified);
      }
    } catch (err) {
      console.warn("Could not parse body as JSON:", err);
    }
    return globalThis.fetch(newUrl, reqInit).then(async (res) => res.json()).then((json) => {
      const base64 = json.data ?? "";
      const bytes = decodeBase64(base64);
      return new Response(bytes, {
        headers: {
          "Content-Type": "audio/mpeg"
          // adjust if needed
        },
        status: 200
      });
    });
  },
  headers: { "player2-game-key": gameKey }
}));

const createSpeaches = (apiKey, baseURL = "http://localhost:8000/v1/") => merge(
  createMetadataProvider("litellm"),
  createSpeechProvider({ apiKey, baseURL }),
  createTranscriptionProvider({ apiKey, baseURL })
);

export { createLMStudio, createLiteLLM, createOllama, createPlayer2, createSpeaches };
